angular
    .module('app.controllers')
    .controller('EditPhaseCtrl', function ($rootScope, $scope, $stateParams, $state, $translate, $http, notify, api, formValidator, UserService, variables) {
        // dane
        const PhaseModel = api('phases');
        const ProjectModel = api('projects');

        $scope.$state = $state;

        $scope.phase = {};
        $scope.phaseOptions = [];
        $scope.isStolcadRequired = false;

        if (0 < $stateParams.id) {
            const info = notify.info($translate.instant('loading'));
            PhaseModel.get($stateParams.id).then((response) => {
                $scope.phase = response;
                $scope.phase.symbol_code = response.project.symbol_code;
                $scope.phase.area_code = response.project.area_code;
                $scope.clientOptions = [];
                if ($scope.phase.client_id) {
                    $scope.clientOptions = [
                        {
                            id: $scope.phase.client_id,
                            name: $scope.phase.client.name,
                        },
                    ];
                }

                if (!$scope.phase.stands) {
                    $scope.phase.stands = [];
                }
                if (!$scope.phase.dispatched_woodwork) {
                    $scope.phase.dispatched_woodwork = [];
                }

                $scope.isStolcadRequired = $scope.phase.project.type === 'installation' || $scope.phase.project.type === 'service';

                $scope.loadTransportEmailLogs();

                info.close();
                notify.success($translate.instant('loaded'));
                $rootScope.$broadcast('edit-panel-ready');

                if (!$scope.phase.project) {
                    notify.error($translate.instant('projects.no_project'));
                    $state.go('restricted.projects');
                }

                // related phases
                api('phases')
                    .selectize({
                        transform: { id: 'id', value: ':symbol :name' },
                        data: { ignore: [$scope.phase.id] },
                    })
                    .then((response) => {
                        $scope.phaseOptions = response.data;
                    });
            });
        } else {
            $scope.phase = {
                id: 0,
                author_id: UserService.getUser().id,
                owner_id: UserService.getUser().id,
                manager_id: UserService.getUser().id,
                status_id: variables.defaults.phase_status_started,
                currency_id: variables.defaults.currency_id,
                country_id: variables.defaults.country_id,
                date_from: moment().format('YYYY-MM-DD'),
                date_to: moment().format('YYYY-MM-DD'),
                realisation: 'unconditional',
                project: {},
                woodworks: [],
                dispatched_woodwork: [],
                stands: [],
                related: [],
                crew_ids: [],
            };

            // related phases
            api('phases')
                .selectize({
                    transform: { id: 'id', value: ':symbol :name' },
                    data: { ignore: [$scope.phase.id] },
                })
                .then((response) => {
                    $scope.phaseOptions = response.data;
                });

            ProjectModel.get($stateParams.pid).then(
                (response) => {
                    $scope.phase.project = response;
                    $scope.phase.symbol_code = response.symbol_code;
                    $scope.phase.area_code = response.area_code;
                    $scope.isStolcadRequired = $scope.phase.project.type === 'installation' || $scope.phase.project.type === 'service';

                    const defaultCrew = `crew_ids_${$scope.phase.project.type}`;
                    if (variables.defaults[defaultCrew]) {
                        $scope.phase.crew_ids.push(variables.defaults[defaultCrew]);
                    }

                    if (!response.id) {
                        $state.go('restricted.projects');
                        notify.error($translate.instant('projects.no_project'));
                    }
                },
                () => {
                    $state.go('restricted.projects');
                    notify.error($translate.instant('projects.no_project'));
                }
            );
        }

        $scope.groupOptions = [];
        api('groups')
            .selectize({ transform: { id: 'id', value: ':name' } })
            .then((response) => {
                $scope.groupOptions = response.data;
            });

        $scope.statusOptions = [];
        api('dictionaries/phase_status')
            .selectize()
            .then((response) => {
                $scope.statusOptions = response.data;
            });

        $scope.carrierOptions = [];
        api('dictionaries/carriers')
            .selectize()
            .then((response) => {
                $scope.carrierOptions = response.data;
            });

        $scope.gradeOptions = [];
        api('dictionaries/phase_grade')
            .selectize()
            .then((response) => {
                $scope.gradeOptions = response.data;
            });

        $scope.countryOptions = [];
        api('dictionaries/countries')
            .selectize()
            .then((response) => {
                $scope.countryOptions = response.data;
            });

        $scope.locationOptions = [];
        api('dictionaries/locations')
            .selectize()
            .then((response) => {
                $scope.locationOptions = response.data;
            });

        $scope.currencyOptions = [];
        api('dictionaries/currencies')
            .selectize()
            .then((response) => {
                $scope.currencyOptions = response.data;
            });

        $scope.vatOptions = [];
        api('dictionaries/vat')
            .selectize()
            .then((response) => {
                $scope.vatOptions = response.data;
            });

        $scope.userOptions = [];
        api('users')
            .selectize({ transform: { id: 'id', value: ':fullname (:job.value)' } })
            .then((response) => {
                $scope.userOptions = response.data;
            });

        $scope.woodworkOptions = [];
        $scope.$watch('phase.project.type', (type) => {
            api('dictionaries/woodwork')
                .selectize()
                .then((response) => {
                    $scope.woodworkOptions = response.data;
                });

            // uproszczony słownik
            $scope.forced_unit_id = null;
            if (type && type.length && 'installation' !== type) {
                $scope.forced_unit_id = variables.defaults.unit_piece_id;
            }
        });

        // autokorekta daty rozpoczęcia/zakończenia
        $scope.$watch('phase.date_from', (dateValue) => {
            if (dateValue) {
                const date_from = moment(dateValue);
                const date_to = moment($scope.phase.date_to);

                if (date_from.isAfter(date_to)) {
                    $scope.phase.date_to = date_from.format('YYYY-MM-DD');
                }

                if (date_from < moment().format('YYYY-MM-DD') || ($scope.phase.project.type !== 'transport' && $scope.phase.project.type !== 'installation')) {
                    $scope.phase_daily_limit = {};
                    return;
                }

                $http.get(`/api/1/phases/limits/check/${$scope.phase.project.type}/${date_from.format('YYYY-MM-DD')}/${$scope.phase.id || 0}`).then(
                    (response) => {
                        $scope.phase_daily_limit = response.data;
                        if (response.data.min_day_buffer) {
                            const minDate = moment().add(response.data.min_day_buffer, 'days').format('YYYY-MM-DD');
                            document.getElementById('dateFrom').dataset.ukDatepicker = "{minDate: '" + minDate + "'}";
                        } else {
                            document.getElementById('dateFrom').dataset.ukDatepicker = '';
                        }
                    },
                    () => {
                        $scope.phase_daily_limit = {};
                    }
                );
            }
        });
        $scope.$watch('phase.date_to', (dateValue) => {
            if (dateValue) {
                const date_to = moment(dateValue);
                const date_from = moment($scope.phase.date_from);

                if (date_to.isBefore(date_from)) {
                    $scope.phase.date_from = date_to.format('YYYY-MM-DD');
                }
            }
        });

        $scope.gross = 0;
        const calculateGross = () => {
            // @todo: refactor
            const value = parseFloat($scope.phase.value);

            const vatCond = { id: parseInt($scope.phase.vat_id) };
            const vatValue = _.find($scope.vatOptions, vatCond);

            if (vatValue) {
                const parsed = parseInt(vatValue.label) || 0;
                $scope.gross = value + (value * parsed) / 100;
            }
        };
        $scope.$watch('phase.value', calculateGross);
        $scope.$watch('phase.vat_id', calculateGross);

        $scope.calculations = [];
        api('areas')
            .get('calculations')
            .then((data) => {
                $scope.calculations = data;
            });

        $scope.units = [];
        api('dictionaries/units')
            .select()
            .then((response) => {
                $scope.units = response.data;
            });

        $scope.installationOptions = [];
        api('dictionaries/installation_type')
            .selectize()
            .then((response) => {
                $scope.installationOptions = response.data;
            });

        $scope.serviceWorkOptions = [];
        api('dictionaries/service_work')
            .selectize()
            .then((response) => {
                $scope.serviceWorkOptions = response.data;
            });

        $scope.serviceTypeOptions = [];
        api('dictionaries/service_type')
            .selectize()
            .then((response) => {
                $scope.serviceTypeOptions = response.data;
            });

        $scope.serviceReasonOptions = [];
        api('dictionaries/service_reason')
            .selectize()
            .then((response) => {
                $scope.serviceReasonOptions = response.data;
            });

        $scope.warrantyReasonOptions = [];
        api('dictionaries/warranty_reason')
            .selectize()
            .then((response) => {
                $scope.warrantyReasonOptions = response.data;
            });

        $scope.transportTypeOptions = [];
        api('dictionaries/transport_type')
            .selectize()
            .then((response) => {
                $scope.transportTypeOptions = response.data;
            });

        $scope.packagingMethodOptions = [];
        api('dictionaries/packaging_method')
            .selectize()
            .then((response) => {
                $scope.packagingMethodOptions = response.data;
            });

        $scope.clientOptions = [];

        $scope.transportEmail = { to: '', title: '', body: '' };
        $scope.transportEmailSending = false;
        $scope.transportEmailLogs = [];
        $scope.loadTransportEmailLogs = () => {
            if (!$scope.phase || !$scope.phase.id) return;
            $http.get(`/api/1/phases/${$scope.phase.id}/transport-emails`).then(
                (response) => {
                    $scope.transportEmailLogs = response.data || [];
                },
                () => {
                    $scope.transportEmailLogs = [];
                }
            );
        };

        $scope.$watchGroup(['phase.symbol', 'calculations'], function () {
            const p = $scope.phase;

            if (!p || !p.project || !$scope.calculations) {
                return;
            }

            if (p.project.client && p.project.client.email) {
                $scope.transportEmail.to = p.project.client.email;
            }

            if (p.symbol && !$scope.transportEmail.title) {
                const stolcad = [];
                for (const woodwork of p.woodworks) {
                    const calc = $scope.calculations[woodwork.woodwork_id];
                    const unit = calc && calc.unit_id ? $scope.units[calc.unit_id] : '';
                    stolcad.push(`${woodwork.stolcad_number}: ${woodwork.value} ${unit}`);
                }

                console.debug('qqq', { stolcad });
                console.debug('qqq', { p });

                const phone = p.manager.company_phone || p.manager.company_cellphone || p.manager.private_phone;
                $scope.transportEmail.title = $translate.instant('phases.transport_email_template_title') + p.symbol;
                $scope.transportEmail.body = $translate
                    .instant('phases.transport_email_template_body')
                    .replace('%stolcad%', stolcad.join('\n- '))
                    .replace('%phone%', phone || '[telefon]')
                    .replace('%date%', p.date_from || '[data]');
            }
        });

        $scope.isClosed = () => $scope.phase.status_id == variables.defaults.phase_status_closed;

        // form validation
        const fv = formValidator('#PhaseForm', $scope);

        const fDetails = formValidator('#PhaseDetailsForm', $scope);

        $scope.savePhase = () => {
            if (!fv.isValid() || !fDetails.isValid()) {
                return;
            }

            if (!$scope.phase.date_to) {
                $scope.phase.date_to = $scope.phase.date_from;
            }
            $scope.phase.project_id = $scope.phase.project.id;

            const redirectAfterSave = 0 == $scope.phase.id;
            const info = notify.info($translate.instant('saving'));
            notify.global(1);

            PhaseModel.save($scope.phase.id, $scope.phase).then((response) => {
                $scope.phase = response;
                PhaseModel.clearCache();

                info.close();
                notify.success($translate.instant('saved'));
                notify.global(0);
                $rootScope.$broadcast('edit-panel-ready');

                if (redirectAfterSave) {
                    $state.go('restricted.phases_edit', { id: $scope.phase.id });
                }
            });
        };

        $scope.addWoodwork = () => {
            $scope.phase.woodworks.push({});
        };

        $scope.removeWoodwork = (i) => {
            $scope.phase.woodworks.splice(i, 1);
        };

        $scope.addServiceWork = (service_work_id = 0, service_reason_id = 0) => {
            $scope.phase.service_works.push({
                service_work_id,
                service_reason_id,
                service_amount: 1,
                service_value: 0,
            });
        };

        $scope.removeServiceWork = (i) => {
            $scope.phase.service_works.splice(i, 1);
        };

        $scope.addStand = () => {
            $scope.phase.stands.push({
                amount: 1,
                width: 10,
                height: 10,
                depth: 10,
            });
        };

        $scope.removeStand = (i) => {
            $scope.phase.stands.splice(i, 1);
        };

        $scope.addDispatchedWoodwork = () => {
            $scope.phase.dispatched_woodwork.push({
                number: 0,
                amount: 0,
            });
        };

        $scope.removeDispatchedWoodwork = (i) => {
            $scope.phase.dispatched_woodwork.splice(i, 1);
        };

        $scope.addRelated = () => {
            $scope.phase.related.push({});
        };

        $scope.removeRelated = (i) => {
            $scope.phase.related.splice(i, 1);
        };

        $scope.phase.service_works = [{}];

        $scope.sendTransportEmail = () => {
            if (!$scope.phase.id) {
                notify.danger($translate.instant('phases.transport_email_save_first'));
                return;
            }
            if (!$scope.transportEmail.to) {
                notify.danger($translate.instant('phases.transport_email_to_required'));
                return;
            }
            $scope.transportEmailSending = true;
            notify.global(1);
            $http
                .post(`/api/1/phases/${$scope.phase.id}/transport-email`, {
                    to: $scope.transportEmail.to,
                    title: $scope.transportEmail.title,
                    body: $scope.transportEmail.body,
                })
                .then(
                    () => {
                        $scope.transportEmailSending = false;
                        notify.global(0);
                        notify.success($translate.instant('sent'));
                        $scope.loadTransportEmailLogs();
                    },
                    (err) => {
                        $scope.transportEmailSending = false;
                        notify.global(0);
                        notify.danger(err.data && err.data.message ? err.data.message : $translate.instant('request_error'));
                    }
                );
        };

        $scope.copyClientData = (field) => {
            notify.global(1);
            const clientId = $stateParams.client || ($scope.phase.project ? $scope.phase.project.client_id : 0);

            api('clients')
                .get(clientId)
                .then((client) => {
                    if (field.includes('address')) {
                        const address = [client.address_name || '', client.address_street || '', `${client.address_postcode || ''} ${client.address_city || ''}`]
                            .join('\n')
                            .replace(/\s+^|\s+$/gi, '');

                        if (address) {
                            $scope.phase[field] = address;
                        } else {
                            notify.danger($translate.instant('clients.copy_data_empty'));
                        }
                    } else if ('phone' === field) {
                        const phone = (client.phone || '').replace(/\s+^|\s+$/gi, '');

                        if (phone) {
                            $scope.phase.phone = phone;
                        } else {
                            notify.danger($translate.instant('clients.copy_data_empty'));
                        }
                    }

                    notify.global(0);
                });
        };
    });
